<p-dialog
        *ngIf="group"
        [dismissableMask]="true"
        (onHide)="onDialogClose()"
        [header]="group.name"
        [modal]="true"
        [(visible)]="group.search_dialog_visible"
        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
        [style]="{ width: '90vw', height: '90vh', maxHeight: '90vh' }"
        [draggable]="false"
        [resizable]="false">
    <div class="content flex h-6rem flex flex-wrap flex-column justify-content-center gap-3">
        <div class="filter-row flex align-items-center ">
            <div class="flex flex-column gap-2">
                <p-iconField iconPosition="left">
                    <p-inputIcon styleClass="pi pi-search"/>
                    <input type="text" pInputText placeholder="Search..." [(ngModel)]="searchText"/>
                    <span class="pi pi-times clear-icon" (click)="clearSearch()"></span>
                </p-iconField>
            </div>
        </div>
        <div class="filter-row">
            <span class="mr-3">Search type: </span>
            <p-dropdown
                    appendTo="body"
                    [options]="searchTypes"
                    [(ngModel)]="selectedSearchType"
                    optionLabel="name"
                    filterBy="name"
                    [placeholder]="'Select search type'"
            >
                <ng-template pTemplate="selectedItem" let-selectedOption>
                    <div class="flex align-items-center gap-2">
                        <div>{{ selectedOption.name }}</div>
                    </div>
                </ng-template>
                <ng-template let-make pTemplate="item">
                    <div class="flex align-items-center gap-2">
                        <div>{{ make.name }}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="filter-row">
            <div class="filter-row flex align-items-center mb-1">
                <span class="mr-3">Make: </span>
                <p-inputSwitch [(ngModel)]="makeEnabled"/>
            </div>
            <div class="flex align-items-center gap-2">
                <p-dropdown
                        appendTo="body"
                        (onClear)="onMakesClear()"
                        [options]="makes"
                        [(ngModel)]="selectedMake"
                        optionLabel="name"
                        [filter]="true"
                        [showClear]="selectedMake != ALL_MAKES_SELECT"
                        filterBy="name"
                        [placeholder]="'Select make'"
                        [disabled]="!makeEnabled"
                >
                    <ng-template pTemplate="selectedItem" let-selectedOption>
                        <div class="flex align-items-center gap-2">
                            <div>{{ selectedOption.name }}</div>
                        </div>
                    </ng-template>
                    <ng-template let-make pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <div>{{ make.name }}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
                <span>images only</span>
            </div>
        </div>
        <div class="filter-row flex align-items-center ">
            <span class="mr-3">No arrows: </span>
            <p-inputSwitch [(ngModel)]="noArrows"/>
        </div>
        <div class="filter-row flex align-items-center ">
            <span class="mr-3">Red arrows: </span>
            <p-inputSwitch [(ngModel)]="redArrows"/>
        </div>
        <div class="filter-row flex align-items-center ">
            <span class="mr-3">Orange arrows: </span>
            <p-inputSwitch [(ngModel)]="orangeArrows"/>
        </div>
        <div class="filter-row flex align-items-center ">
            <span class="mr-3">Yellow arrows: </span>
            <p-inputSwitch [(ngModel)]="yellowArrows"/>
        </div>
        <div class="filter-row flex align-items-center ">
            <span class="mr-3">Green arrows: </span>
            <p-inputSwitch [(ngModel)]="greenArrows "/>
        </div>
        <div class="filter-row flex align-items-center ">
            <span class="mr-3">Images w/ notes only: </span>
            <p-inputSwitch [(ngModel)]="imagesWithoutNotes"/>
        </div>
        <div class="filter-row flex align-items-center ">
            <span class="mr-3">Search notes: </span>
            <p-inputSwitch [(ngModel)]="searchNotes"/>
        </div>
        <div class="filter-row flex align-items-center ">
            <span class="mr-3">Approved only: </span>
            <p-inputSwitch [(ngModel)]="approvedOnly"/>
        </div>

    </div>

    <div class="flex  mt-2">
        <div class="search-btn w-3 mx-auto">
            <p-button
                    label="Search"
                    [loading]="loading"
                    styleClass="w-full"
                    size="small"
                    [disabled]="!searchText"
                    (onClick)="search()"/>
        </div>
        <div class="upload-btn">
            <p-button
                    label="Upload"
                    styleClass="w-full"
                    size="small"
                    (onClick)="group.upload_dialog_visible = true"/>
        </div>
    </div>

    <main
            (scroll)="onScroll($event)"
            style="height: 600px;overflow-y: auto;"
            class="grid justify-content-between mt-2 gap-3">
        @for (image of images; track image.score_red_color) {
            <p-card class="image" header="{{ image.topic_name }}"
                    subheader="{{ image.action_name }}"
                    [style]="{ width: '360px' }">
                <ng-template pTemplate="header">
                    <div style="position:relative">
                        <p-image
                                src="https://insp-img.autotechiq.com/webp/{{ image.webp }}"
                                alt="Image"
                                [preview]="true"/>
                        <div *ngIf="image.manual_upload" style="position:absolute; top: 10px; right: 10px">
                                                <span style="background: white; padding: 5px; border-radius: 5px; text-align: center; display: flex;">
                                                <i class="pi pi-upload"
                                                   [pTooltip]="'Manually uploaded image'"
                                                   style="font-size: 1.25rem; color:#3B82F6;"></i>
                                                </span>
                        </div>
                    </div>
                </ng-template>
                <p-divider></p-divider>
                <p class="notes">
                    <span class="flex align-items-center gap-2">
                        <b>Notes:</b>
                    </span>
                    <i>{{ image.caption }}</i></p>

                <ng-template pTemplate="footer">
                    <div *ngIf="groupSelectedMake && groupSelectedMake !== ALL_MAKES_SELECT" class="approve mb-2">
                        <p class="flex  align-items-center justify-content-between mb-3">
                            <span><strong>Approved: </strong></span>
                            <p-checkbox
                                    [binary]="true"
                                    inputId="binary"
                                    class="checkbox-approve"
                                    (onChange)="this.onChangeCheckbox(image, $event)"
                                    [(ngModel)]="image.approved"
                            />
                        </p>
                    </div>
                    <div class="w-full flex align-self-end gap-2 ml-auto">
                        <p-button
                                [pTooltip]="'Approve for all makes'"
                                icon="pi pi-list-check"
                                [rounded]="true"
                                [outlined]="true"
                                (click)="approveAllMakes(image, group)"/>
                        <p-button
                                [pTooltip]="'Edit image'"
                                icon="pi pi-image"
                                [rounded]="true"
                                [outlined]="true"
                                (click)="openEditImage(image)"/>
                    </div>
                </ng-template>
            </p-card>
        }
        <div class="flex w-full justify-content-center">
            <p-progressSpinner
                    *ngIf="loading"
                    styleClass="w-4rem h-4rem"
                    strokeWidth="4"
                    animationDuration="1s"/>
        </div>
        <app-approve-all-makes-btn
                [dialogVisible]="approveAllMakesDialogVisible"
                (onVisibilityChanged)="onVisibilityApproveDialogChange($event)"/>

        <app-image-editor
                (onImageUploadEvent)="onImageUploadEvent.emit(true)"/>
    </main>
</p-dialog>